import { getCaseWithTopics, updateCaseTopics } from '../../../actions/case-actions';
import Swal from 'sweetalert2';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import '../../../styles/cases.css';
import { Link, useParams } from 'react-router-dom';

function EditCaseTopics(){
    const currentLink = "/casos/buscar";
    const dispatch = useDispatch();
    const [loadData, setLoadData] = useState(true);
    const params = useParams();
    const user = useSelector(state => state.user.user);

    const [currentData, setCurrentData] = useState({});

    const [form, setForm] = useState({
        legalCaseID: '',
        topics: [{ name: '', subtopics: []}],
        decisions: '',
        arguments: '',
        speech: '',
        comments: [{ comment: '' }],
    })

    useEffect(() => {
        if (loadData) {
            const getFunction = (data) => {
                if(data.code === "01"){
                    Swal.fire({
                        title:"Error",
                        confirmButtonColor:"#76b4ff",
                        text: data.message
                    });
                }else{
                    //console.log(data.data);
                    setCurrentData(data.data);

                    setForm({
                        ...form,
                        ...data.data.topics
                    });
                    /*
                    Pendiente mostrar datos pertinentes del caso
                    let clientPosition = `${data.data.case.statePosition === 'ex'?'ex':''} ${data.data.case.position}`;
                    data.data.clientText = `${data.data.client.clientId.firstName} ${data.data.client.clientId.lastName} ${data.data.client.clientId.documentType}: ${data.data.client.clientId.document} - ${clientPosition}`.toLocaleUpperCase();
                    data.data.entityText = `${data.data.case.territorialEntity} - ${data.data.case.executionCity} ${data.data.case.executionProvince}`.toLocaleUpperCase();
                    data.data.companyText = `${data.data.company.companyId.description} - ${data.data.company.companyId.city} ${data.data.company.companyId.province}`.toLocaleUpperCase();

                    for (let index = 0; index < investigationTypes.length; index++) {
                        if (data.data.caseType === investigationTypes[index].value) {
                            data.data.caseType = investigationTypes[index].name.toLocaleUpperCase()
                        }
                    }

                    switch (data.data.city) {
                        case 'Cali':
                            setCurrentCityPlaceholder({
                                ...placeholders.cali
                            })
                            break;
                        case 'Palmira':
                            setCurrentCityPlaceholder({
                                ...placeholders.palmira
                            })
                            break;
                        default:
                            break;
                    }

                    setCurrentData(data.data);

                    setForm({
                        ...form,
                        ...data.data.legalityControl,
                    })
                    */
                }
            }

            setLoadData(false);
            setForm({
                legalCaseID: '',
                topics: [{ name: '', subtopics: []}],
                decisions: '',
                arguments: '',
                speech: '',
                comments: [{ comment: '' }],
            });

            dispatch( getCaseWithTopics( params.id, getFunction, user.token ) );
        }
    }, [loadData, dispatch, params.id, form, user.userType, user.token ]);

    const handleInputChange = (event) => {
        setForm({
            ...form,
            [event.target.name] :  event.target.value
        })
    }

    let handleDinamycChange = (option, index, event) => {
        let newFormValues = {...form};
        switch (option) {
            case 1:
                newFormValues.topics[index].name = event.target.value;
                break;
            case 2:
                newFormValues.comments[index].comment = event.target.value;
                break;
            default:
                newFormValues.topics[index].name = event.target.value;
                break;
        }
        setForm(newFormValues);
    }

    let handleSubtopicChange = (topicIdx, subtopicIdx, event) => {
        let newFormValues = {...form};
        newFormValues.topics[topicIdx].subtopics[subtopicIdx] = event.target.value;
        setForm(newFormValues);
    }

    let addTopic = () => {
        let newFormValues = {...form};
        newFormValues.topics.push({ name: "", subtopics: [] });
        setForm({...newFormValues});
    }
        
    let addSubtopic = (index) => {
        let newFormValues = {...form};
        newFormValues.topics[index].subtopics.push("");
        setForm({...newFormValues});
    }

    let addComment = () => {
        let newFormValues = {...form};
        newFormValues.comments.push({ comment: '' });
        setForm({...newFormValues});
    }
    
    let deleteTopic = (i) => {
        if (form.topics.length > 1) {
            let newFormValues = {...form};
            newFormValues.topics.splice(i, 1);
            setForm({...newFormValues});
        }
    }

    let deleteSubtopic = (topicIdx, subtopicIdx) => {
        if (form.topics[topicIdx].subtopics.length > 0) {
            let newFormValues = {...form};
            newFormValues.topics[topicIdx].subtopics.splice(subtopicIdx, 1);
            setForm({...newFormValues});
        }
    }

    let deleteComment = (i) => {
        if (form.comments.length > 1) {
            let newFormValues = {...form};
            newFormValues.comments.splice(i, 1);
            setForm({...newFormValues});
        }
    }

    const handleOnSubmit = (event) => {
        event.preventDefault();
        dispatch( updateCaseTopics( form, updateFunct, user.token) );
    }

    const updateFunct = (data) => {
        if(data.code === "01"){
            Swal.fire({
                title:"Error",
                confirmButtonColor:"#76b4ff",
                text: data.message
            });
        }else{
            //navigate(currentLink)
            console.log(data);
            Swal.fire({
                title:"¡Éxito!",
                confirmButtonColor:"#76b4ff",
                text: "Información actualizada dentro del banco temático con éxito"
            });
        }
    }

    useEffect(() => {
        //console.log(form);
    }, [ form ]);

    return(
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <div className="w-100 mt-5">
                    <Link to={`${currentLink}`} className="back-button">&#60; Volver</Link>
                </div>
                {Object.keys(currentData).length > 0?<h1 className="my-5">Banco temático Exp. {currentData.filingNumber}</h1>:null}
                {Object.keys(currentData).length > 0?
                    <form className="d-flex w-100 flex-wrap" onSubmit={handleOnSubmit}>
                        <h4 className="w-100 my-2">Temas</h4>
                        {form.topics.map(( topic, index) => (
                            <div className='d-flex w-100 flex-wrap position-relative topic-container' key={index}>
                                <div className="d-flex w-100">
                                    <div className="d-flex flex-column w-25 field">
                                        <label className="label-field" htmlFor={`name${index}`}>Tema {index + 1}</label>
                                        <input id={`name${index}`} name={`name${index}`} autoComplete="off" maxLength={100} className="input-field" type="text" onChange={(e)=>handleDinamycChange(1,index,e)} value={topic.name}></input>
                                    </div>
                                </div>
                                <span className='delete-topic-button' onClick={()=>deleteTopic(index)}>&#120;</span>
                                {topic.subtopics.length > 0?
                                    topic.subtopics.map(( subtopic, subtopicIndex ) => (
                                        <div className="d-flex flex-column w-25 field position-relative" key={`${index}${subtopicIndex}`}>
                                            <label className="label-field" htmlFor={`subtopic${index}${subtopicIndex}`}>Subtema {subtopicIndex + 1}</label>
                                            <input id={`subtopic${index}${subtopicIndex}`} name={`subtopic${index}${subtopicIndex}`} autoComplete="off" maxLength={100} className="input-field" type="text" onChange={(e)=>handleSubtopicChange(index, subtopicIndex, e)} value={subtopic}></input>
                                            <span className='delete-topic-button subtopic' onClick={()=>deleteSubtopic(index, subtopicIndex)}>&#120;</span>
                                        </div>
                                    ))
                                :
                                    <span className='field' style={{display: 'inline-flex', alignItems: 'center'}}>Dé click para añadir un subtema</span>
                                }
                                <div className="d-flex align-items-center field">
                                    <button className='add-icon-button small' type='button' onClick={() => addSubtopic(index)}>&#43;</button>
                                </div>
                            </div>
                        ))}
                        <div className="d-flex justify-content-center w-100 my-2">
                            <button className='add-text-button' type='button' onClick={addTopic}>Añadir tema</button>
                        </div>
                        <h4 className="w-100 my-2">Datos generales</h4>
                        <div  className="d-flex flex-column w-100 field">
                            <label className="label-field" htmlFor={'decisions'}>Decisiones</label>
                            <textarea id={'decisions'} name={'decisions'} autoComplete="off" rows={5} cols={5} className="input-field" onChange={handleInputChange} value={form.decisions}></textarea>
                        </div>
                        <div  className="d-flex flex-column w-100 field">
                            <label className="label-field" htmlFor={'arguments'}>Argumentos</label>
                            <textarea id={'arguments'} name={'arguments'} autoComplete="off" rows={5} cols={5} className="input-field" onChange={handleInputChange} value={form.arguments}></textarea>
                        </div>
                        <div  className="d-flex flex-column w-100 field">
                            <label className="label-field" htmlFor={'speech'}>Discurso</label>
                            <textarea id={'speech'} name={'speech'} autoComplete="off" rows={5} cols={5} className="input-field" onChange={handleInputChange} value={form.speech}></textarea>
                        </div>
                        <h4 className="w-100 my-2">Comentarios</h4>
                        {form.comments.map(( comment, index) => (
                            <div key={index} className="d-flex flex-column w-100 field position-relative">
                                <label className="label-field" htmlFor={`speech${index}`}>Comentario {index + 1}</label>
                                <textarea id={`speech${index}`} name={`speech${index}`} autoComplete="off" rows={2} cols={5} className="input-field" onChange={(e)=>handleDinamycChange(2,index,e)} value={comment.comment}></textarea>
                                <span className='delete-topic-button' onClick={()=>deleteComment(index)}>&#120;</span>
                            </div>
                        ))}
                        <div className="d-flex justify-content-center w-100 my-2">
                            <button className='add-text-button' type='button' onClick={addComment}>Añadir otro comentario</button>
                        </div>
                        <div className="d-flex justify-content-center w-100 my-2">
                            <button type="submit" className="primary-button save-button">Guardar</button>
                        </div>
                    </form>
                :
                    null
                }                
            </div>
        </div>
    );
}

export default EditCaseTopics;